{
  "list": {
    "title": "Notificaciones"
  },
  "planExport": {
    "download": "Descargar",
    "view": "Ver",
    "completed": "completado",
    "failed": "no se pudo completar",
    "inProgress": "está en progreso",
    "export": "exportar",
    "completedStatus": "Finalizado",
    "failedStatus": "Falló",
    "inProgressStatus": "En progreso"
  },
  "markAsRead": "Marcar como leído",
  "noNotifications": "Actualmente no hay notificaciones.",
  "layersImport": {
    "in-progress": {
      "title": "Importación de capas",
      "description": "Importación de capas: {{ name }}"
    },
    "completed": {
      "title": "Importación de capas completada",
      "description": "Se completó la importación de capas: {{ name }}"
    },
    "failed": {
      "title": "No se pudieron importar las capas",
      "description": "No se pudieron importar las capas: {{ name }}"
    },
    "goToMap": "Ir al mapa"
  },
  "layersCopy": {
    "in-progress": {
      "title": "Copiar capas",
      "description": "Copiar capas: {{ name }}"
    },
    "completed": {
      "title": "Se completó la copia de capas",
      "description": "Se ha completado la copia de capas"
    },
    "failed": {
      "title": "No se pudieron copiar las capas",
      "description": "No se pudieron copiar las capas: {{ name }}"
    },
    "goToMap": "Ir al mapa"
  },
  "layersUnlink": {
    "in-progress": {
      "title": "Desvincular capas",
      "description": "Desvincular capas: {{ name }}"
    },
    "completed": {
      "title": "Se ha completado la desvinculación de capas",
      "description": "Se ha completado la desvinculación de capas"
    },
    "failed": {
      "title": "No se pudieron desvincular las capas",
      "description": "No se pudieron desvincular las capas: {{ name }}"
    },
    "goToMap": "Ir al mapa"
  },
  "mapsCopy": {
    "in-progress": {
      "title": "Copiando planes",
      "description": "Copiando a: {{ destinationName }}"
    },
    "completed": {
      "title": "Copiar los planes completados",
      "description": "Copiado a: {{ destinationName }}"
    },
    "goToLocation": "Ve a {{ destinationName }}",
    "teamMapLimitReached": "Se ha alcanzado el límite de planes de equipo.",
    "somePlansWereNotCopied": "Algunos planes no se copiaron.",
    "somePlansFailedToCopy": "Algunos planes no se copiaron."
  }
}